var checkout = (function( $ ) {

	var $selector;

	var $overview;

	var _init = function() {
		$selector = $( 'select[name="crate-subscription-select"]' );
		$overview = $( '.subscription-overview' );

		if ( $( 'body' ).hasClass( 'woocommerce-checkout' ) ) {
			if ( $selector.length > 0 ) {
				$selector.on( 'change', _change_subscription );
			}

			if ( $overview.length > 0 ) {
				$( 'body' ).on( 'update_checkout', _update_overview );
			}

			$( 'body' ).on( 'update_checkout', _update_totals );
			$( 'body' ).on( 'updated_checkout', _setup_payment_method_toggle );

			var is_paypal = $( 'input[name="payment_method"]:checked' ).val() === 'braintree_paypal';

			_toggle_address_fields( is_paypal );
		}
	};

	var _setup_payment_method_toggle = function() {
		$( 'input[name="payment_method"]' ).on( 'change', function() {
			var is_paypal = $( 'input[name="payment_method"]:checked' ).val() === 'braintree_paypal';

			_toggle_address_fields( is_paypal );
		} );
	};

	var _toggle_address_fields = function( hide ) {
		var fields = [
			'#billing_address_1_field',
			'#billing_address_2_field',
			'#billing_city_field',
			'#billing_state_field',
			'#billing_postcode_field'
		];

		$.each( fields, function( index, field ) {
			if ( hide ) {
				$( field ).slideUp();
			} else {
				$( field ).slideDown();
			}
		} );
	};

	var _update_totals = function ( e ) {
		$( '.cart_totals' ).loading();

		$.post( ScriptData.ajaxurl, {
			action: 'crate_checkout_update_totals',
			nonce: ScriptData.crate_checkout_update_totals_nonce
		}, _update_totals_response );
	};

	var _update_totals_response = function( response ) {
		$( '.cart_totals' ).replaceWith( response.html );
	};

	var _update_overview = function( e ) {
		$overview.prepend( '<div class="overview-overlay"></div>' );

		var data = {
			action : 'crate_subscription_overview',
			nonce  : ScriptData.crate_subscription_overview_nonce
		};

		$.post( ScriptData.ajaxurl, data, _update_overview_response );
	};

	var _update_overview_response = function( response ) {
		if ( response.html ) {
			$overview.replaceWith( response.html );
			$overview = $( '.subscription-overview' );
		}
	};

	var _toggle_loading = function() {
		$selector.closest( '.crate-subscription-select-wrapper' ).toggleClass( 'loading' );
		$selector.next( '.ajax-spinner' ).toggleClass( 'active' );
	};

	var _change_subscription = function( e ) {
		_toggle_loading();

		var val = $( this ).val();

		var $selected = $( this ).find( 'option[value="' + val + '"]' );

		var url_to_change = $selected.data( 'url' );

		if ( url_to_change ) {
			window.location.href = url_to_change;
			return;
		}

		var data = {
			action : 'crate_checkout_change_subscription',
			nonce  : ScriptData.crate_checkout_change_subscription_nonce,
			product_id : $( this ).val()
		};

		$.post( ScriptData.ajaxurl, data, _change_subscription_response );
	};

	var _change_subscription_response = function( response ) {
		if ( response.success ) {
			window.location.reload();
		}

		if ( response.error ) {
			var $form = $( 'form[name="checkout"]' );
			var $notice_group = $( '.woocommerce-NoticeGroup' );

			if ( ! $notice_group.length > 0 ) {
				$form.prepend( '<div class="woocommerce-NoticeGroup woocommerce-NoticeGroup-checkout"></div>' );
				$notice_group = $( '.woocommerce-NoticeGroup' );
			}

			var $errors = $notice_group.find( '.woocommerce-error' );

			if ( ! $errors.length > 0 ) {
				$notice_group.prepend( '<ul class="woocommerce-error" role="alert"></ul>');
				$errors = $notice_group.find( '.woocommerce-error' );
			}

			var $error = $errors.find( 'li.subscription-switch' );

			if ( $error.length > 0 ) {
				$error.text( response.error  );
			} else {
				$errors.append(  '<li class="subscription-switch">' + response.error + '</li>' );
			}

			_toggle_loading();
		}
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = checkout;